import { FelaCSS, colors, FelaCSSWithCustomSelectors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  header: FelaCSS;
  subheader: FelaCSS;
  itemWrap: FelaCSS;
  question: FelaCSS;
  answer: FelaCSSWithCustomSelectors;
  buttonWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    paddingHorizontal: 10,
    paddingVertical: 20,
    alignItems: 'center',
    maxWidth: 1000,
  },

  header: {
    textAlign: 'center',
    fontDefaultSemiBold: 32,
    lineHeight: 1.3,
    marginBottom: 10,
    maxWidth: 800,

    desktopDesign: {
      fontDefaultSemiBold: 48,
    },
  },

  subheader: {
    textAlign: 'center',
    fontDefault: 16,
    marginBottom: 4,
    maxWidth: 800,
    lineHeight: 1.5,

    desktopDesign: {
      fontDefault: 20,
      marginBottom: 12,
    },
  },

  itemWrap: {
    width: '100%',

    ':not(:last-of-type)': {
      borderBottom: `1px solid ${colors.space08}`,
    },
  },

  question: {
    paddingVertical: 6,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    cursor: 'pointer',
    fontDefault: 20,

    desktopDesign: {
      paddingVertical: 10,
      fontDefault: 24,
    },

    hover: {
      textDecoration: 'underline',
    },
  },

  answer: {
    fontDefault: 16,
    marginBottom: 6,
    color: colors.space75,
    lineHeight: 1.5,

    desktopDesign: {
      fontDefault: 18,
      marginBottom: 10,
    },

    '& p': {
      marginBottom: spacing[5],
    },

    '& ol': {
      display: 'block',
      marginTop: 0,
      paddingLeft: spacing[10],
      marginBottom: spacing[8],

      '& li': {
        listStyleType: 'decimal',
        marginBottom: spacing[4],
      },
    },

    '& ul': {
      listStyleType: 'disc',
      display: 'block',
      paddingLeft: spacing[10],
      marginBottom: spacing[8],

      '& li': {
        listStyleType: 'disc',
        marginBottom: spacing[4],
      },
    },

    '& b, & strong': {
      fontDefaultSemiBold: 'inherit',
    },

    '& a': {
      textDecoration: 'underline',
      cursor: 'pointer',
      color: colors.indigoCrush,
    },
  },

  buttonWrap: {
    marginTop: 10,
  },
});

export default styles;
